export const ADD_OR_UPDATE_DAMAGE_REPORT_IN_CACHE = 'ADD_OR_UPDATE_DAMAGE_REPORT_IN_CACHE';
export const REMOVE_DAMAGE_REPORT_FROM_CACHE = 'REMOVE_DAMAGE_REPORT_FROM_CACHE';

export const addOrUpdateDamageReportInCache = (data) => ({ type: ADD_OR_UPDATE_DAMAGE_REPORT_IN_CACHE, payload: data });

export const removeDamageReportFromCache = (data) => ({ type: REMOVE_DAMAGE_REPORT_FROM_CACHE, payload: data });
